import React, {useEffect} from 'react';
import {curry} from 'ramda';
import wrap from 'wraptile';

import {BlankChangeEvent} from '@pluto/@types';
import Users from './Users';
import {
    UsersContainerProps,
    HandleChangeProps,
    UserOption,
} from './UsersTypes';

export const onEffect = wrap((setUsers: () => void, isLoading: boolean) => {
    if (isLoading)
        setUsers();
});

export const getOptionSelected = (option: string, value: string) => {
    return option === value;
};

export const getOptionLabel = (option: string) => {
    return option || '';
};

export const findSelected = curry((value: string, user: UserOption) => user.email === value);

export const handleChange = curry((props: HandleChangeProps, _event: BlankChangeEvent, value: string | null) => {
    const {
        onChange,
        rows,
    } = props;
    
    if (!value)
        return onChange(null);
    
    const selected = rows.find(findSelected(value)) || null;
    onChange(selected);
});

export default function UsersContainer(props: UsersContainerProps) {
    const {
        setUsers,
        rows,
        onChange,
        isLoading,
        assignedUser,
    } = props;
    const onSelectChange = handleChange({
        onChange,
        rows,
    });
    
    const fetchUsers = onEffect(setUsers, isLoading);
    
    useEffect(fetchUsers, []);
    
    return (
        <Users
            assignedUser={assignedUser}
            opts={rows}
            getOptionSelected={getOptionSelected}
            getOptionLabel={getOptionLabel}
            onChange={onSelectChange as any}
        />
    );
}
